import api from './client.js'

export const spotifyAPI = {
  getAuthUrl: () => api.get('/spotify/auth-url'),
  manualAuth: (callbackUrl) => api.post('/spotify/manual-auth', { callbackUrl }),
  getSettings: () => api.get('/spotify/settings'),
  updatePlaylistConfig: (playlistId) => api.put('/spotify/playlist', { playlistId }),
  disconnect: () => api.post('/spotify/disconnect'),
  searchTracks: (query, limit = 20) => api.get('/spotify/search', { params: { q: query, limit } }),
  getPlaylist: () => api.get('/spotify/playlist'),
  addTrackToPlaylist: (trackUri) => api.post('/spotify/add-track', { trackUri }),
  getCurrentlyPlaying: () => api.get('/spotify/now-playing'),
}
